export default __webpack_public_path__ + "static/media/Chat-Numbers-System-02.c4daee28.svg";